const GreffierMapMandataireListStyle = {
  height: "100%",
  width: "600px",
};

export { GreffierMapMandataireListStyle };
